module.exports = __webpack_public_path__ + "img/zhongdu2_icon.d0e114ed.gif";